export const landingPageClasses = 'landing-page tablet lg:desktop';
export const productPageClasses = 'product-page tablet lg:desktop';
export const lessonPageClasses = 'lesson-page tablet lg:desktop';
export const editorPageClasses = 'editor-page tablet lg:desktop';
